// HeaderItem.js
import React from "react";
import PropTypes from "prop-types";
import headerItmeStyle from "./HeaderItemStyle.module.css";

const HeaderItem = ({
  id,
  customIcon,
  text = [],
  padding = "12px",
  color = "#000",
  isOpen,
  toggleDropdown,
  myHanderFunc,
  children,
}) => {
  const hasDropdown = text.length > 0 || children;

  const handleIconClick = () => {
    if (hasDropdown) {
      toggleDropdown();
    } else {
      myHanderFunc(null, id);
    }
  };

  const handleItemClick = (e, item) => {
    e.stopPropagation();
    myHanderFunc(item, id);

    if (hasDropdown) {
      toggleDropdown();
    }
  };


  return (
    <div
      className={`${headerItmeStyle.profile_dropdown} ${
        isOpen ? headerItmeStyle.open : ""
      }`}
      style={{ position: "relative", zIndex: 1 }}
    >
      <div
        className={headerItmeStyle.profile_ic}
        style={{ padding, color, cursor: "pointer" }}
        onClick={handleIconClick}
      >
        {customIcon}
      </div>

      {isOpen && hasDropdown && (
        <div className={headerItmeStyle.dropdown_content}>
          {text.length > 0 ? (
            <ul>
              {text.map((item, index) => (
                <li key={index} onClick={(e) => handleItemClick(e, item)}>
                  {item}
                </li>
              ))}
            </ul>
          ) : (
            children
          )}
        </div>
      )}
    </div>
  );
};

HeaderItem.propTypes = {
  id: PropTypes.string.isRequired,
  customIcon: PropTypes.element,
  text: PropTypes.arrayOf(PropTypes.string),
  padding: PropTypes.string,
  color: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  toggleDropdown: PropTypes.func.isRequired,
  myHanderFunc: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default HeaderItem;
